import { useState, useCallback } from 'react'
import axios from 'axios'

async function getFileBlob(fileUri) {
  // Wrap resolveLocalFileSystemURL in a Promise

  console.log("fileUri", fileUri);

  const getFileEntry = (uri) => {
    return new Promise((resolve, reject) => {
      window.resolveLocalFileSystemURL(uri, resolve, reject);
    });
  };

  // Wrap fileEntry.file in a Promise
  const getFile = (fileEntry) => {
    return new Promise((resolve, reject) => {
      fileEntry.file(resolve, reject);
    });
  };

  // Wrap FileReader in a Promise
  const readAsArrayBuffer = (file) => {
    return new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.onloadend = () => resolve(reader.result);
      reader.onerror = reject;
      reader.readAsArrayBuffer(file);
    });
  };

  try {
    const fileEntry = await getFileEntry(fileUri);
    console.log("fileEntry", fileEntry);
    const file = await getFile(fileEntry);
    console.log("file", file);
    const arrayBuffer = await readAsArrayBuffer(file);
    const blob = new Blob([new Uint8Array(arrayBuffer)], { type: file.type });
    blob.name = file.name;
    return blob;
  } catch (err) {
    console.error("Error getting file blob:", err);
    throw err;
  }
}



export default ({ path, onComplete }) => {
  const [isPending, setIsPending] = useState(false)
  const [progress, setProgress] = useState(0)

  const uploadFile = useCallback(async (eventOrIntentFile) => {
    let file = null

    if(eventOrIntentFile?.target?.files) {
      file = eventOrIntentFile.target.files[0]
    } else {
      file = await getFileBlob(eventOrIntentFile.uri)
      let parts = eventOrIntentFile.path.split('/')
      file.name = parts[parts.length - 1]
      // file = { path: eventOrIntentFile.path }
    }

    if (!file) return

    setIsPending(true)

    const formData = new FormData()
    formData.append('file', file, file.name)

    try {
      const response = await axios.post(path, formData, {
        headers: { 'Content-Type': 'multipart/form-data' },
        // Track upload progress
        onUploadProgress: (progressEvent) => {
          const percentCompleted = Math.round(
            (progressEvent.loaded * 100) / progressEvent.total
          )
          setProgress(percentCompleted)
        },
      })

      if(onComplete) onComplete()
    } catch (error) {
      console.error('Upload error:', error);
    }

    setIsPending(false)
    setProgress(0)
  })

  return { isPending, uploadFile }
}
